import React, { useState } from "react";
import placeImage from "../../images/placeholder.jpg";
import NoData from "../../Component/NoData";
import Dataloader from "../../Component/Dataloader";
import NumberFormatter from "../../Component/NumberFormatter";

export default function TransporterOrder({ orderList, dataLoading }) {
    const [orderDetail, setOrderDetail] = useState("");

    const imageOnError = (event) => {
        event.currentTarget.src = placeImage;
    };

    const handleProductDetail = (data) => {
        setOrderDetail("");
        if (data) {
            setOrderDetail(data);
        }
    };

    return (
        <>
            {dataLoading ? (
                <div className="d-flex justify-content-center">
                    <Dataloader />
                </div>
            ) : (
                <>
                    {orderList.length > 0 ? (
                        <div className="row g-3">
                            {orderList.map((order, index) => (
                                <div className="col-lg-6 px-2" key={index}>
                                    <div className="order-product">
                                        <div className="row align-items-center">
                                            <div className="col-3">
                                                <div className="order-image">
                                                    <img
                                                        src={order.commodity_product.thumbnail}
                                                        onError={imageOnError}
                                                        alt="product"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-8 ps-0">
                                                <div className="order-detail">
                                                    <h6 className="one-line-clamp">
                                                        <span className="me-2">Quotation No:</span>
                                                        {order.unique_id}
                                                    </h6>
                                                    <h6 className="one-line-clamp">
                                                        {order.commodity_product.name}
                                                    </h6>
                                                    <div className="order-tag">
                                                        <div>
                                                            <span className="f-500">Brand:</span>
                                                            <span>{order.brand.name}</span>
                                                        </div>
                                                        <div>
                                                            <span className="f-500">Location:</span>
                                                            <span>Ex-{order.origin_city}</span>
                                                        </div>
                                                        <div>
                                                            <span className="f-500">Category:</span>
                                                            <span>{order.commodity_product.category.name}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <h6
                                                className={`status ${order.status === "pending" ? "pending" : "delivered"
                                                    }`}
                                            >
                                                {order.status}
                                            </h6>
                                        </div>
                                        <div className="row order-product-btn">
                                            <div className="col-lg-12 d-flex justify-content-center">
                                                <button
                                                    type="button"
                                                    className="ord-btn invc"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#productDeatilModal"
                                                    title="Order Detail"
                                                    onClick={() => handleProductDetail(order)}
                                                >
                                                    <i className="bi bi-basket2 me-1"></i>Order Details
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <NoData />
                    )}
                </>
            )}

            {/**Product Detail Modal*/}
            <div
                className="modal fade"
                id="productDeatilModal"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex="-1"
                aria-labelledby="productDeatilModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
                    <div className="modal-content custom-modal">
                        <div className="header">
                            <h5 className="title">
                                Order Detail - {orderDetail && orderDetail.commodity_product.name}
                            </h5>
                            <button
                                type="button"
                                className="custom-btn bg-warning rounded-2 text-dark"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                Cancel
                            </button>
                        </div>
                        <div className="body">
                            {orderDetail && (
                                <div className="row g-3">
                                    <div className="col-lg-4">
                                        <figure className="h-100">
                                            <img
                                                src={orderDetail.commodity_product.thumbnail}
                                                onError={imageOnError}
                                                alt={orderDetail.commodity_product.name}
                                                className="img-fluid w-100 h-100"
                                            />
                                        </figure>
                                    </div>
                                    <div className="col-lg-8">
                                        <table className="custom_table">
                                            <tbody>
                                                <tr>
                                                    <td>Quotation No:</td>
                                                    <td>
                                                        <span>{orderDetail.unique_id}</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Order Id:</td>
                                                    <td>
                                                        <span>{orderDetail.order_id}</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Name:</td>
                                                    <td>
                                                        <span>{orderDetail.commodity_product.name}</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Brand:</td>
                                                    <td>
                                                        <span>{orderDetail.brand.name}</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Category:</td>
                                                    <td>
                                                        <span>
                                                            {orderDetail.commodity_product.category.name}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Origin City:</td>
                                                    <td>
                                                        <span>{orderDetail.origin_city}</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Description:</td>
                                                    <td>
                                                        <span>{orderDetail.description}</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="col-lg-12">
                                        <p className="fw450 text-success">
                                            Freight:
                                            <span className="ms-3">
                                                Rs <NumberFormatter number={orderDetail.transport_price} />
                                                /MT
                                            </span>
                                        </p>
                                    </div>

                                    <div className="col-lg-12 border-top">
                                        <p className="mt-1 fw450 text-primary">Consignee Detail:</p>
                                        <table className="custom_table mt-1">
                                            <tbody>
                                                <tr>
                                                    <td>Company Name:</td>
                                                    <td>
                                                        <span>
                                                            {orderDetail.consignee_detail.company_name}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Address Line 1:</td>
                                                    <td>
                                                        <span>
                                                            {orderDetail.consignee_detail.address_line_one}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Address Line 2:</td>
                                                    <td>
                                                        <span>
                                                            {orderDetail.consignee_detail.address_line_two}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Phone Number:</td>
                                                    <td>
                                                        <span>{orderDetail.consignee_detail.phone}</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>City:</td>
                                                    <td>
                                                        <span>{orderDetail.consignee_detail.city}</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>State:</td>
                                                    <td>
                                                        <span> {orderDetail.consignee_detail.state}</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pincode:</td>
                                                    <td>
                                                        <span>{orderDetail.consignee_detail.pincode}</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    {orderDetail.loading_address.map((address, index) => (
                                        <div className="col-lg-12 border-top" key={index}>
                                            <p className="mt-1 fw450 text-primary">
                                                Loading Address {index + 1}:
                                            </p>
                                            <table className="custom_table mt-1">
                                                <tbody>
                                                    <tr>
                                                        <td>Address Line 1:</td>
                                                        <td>
                                                            <span>{address.address_line_one}</span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Address Line 2:</td>
                                                        <td>
                                                            <span>{address.address_line_two}</span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Pincode:</td>
                                                        <td>
                                                            <span>{address.pincode}</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
